
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import React, { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PurchaseReceiveActionMenu from "../receives/PurchaseReceivesMenu";
import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";

import UseIssuedIndentNumberListOnReturn from "../../../hooks/useIssuedIndentNumberListOnReturn";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useReturnIndentNumber from "../../../hooks/useReturnIndentCode";
import useLoadReturnIssueDetailByRequestNumber from "../../../hooks/useReturnLoadIssueDetailByID";
import useReturnIndentCRUD from "../../../hooks/useReturnIndentCRUD";
import useEmployeeByDepartmentID from "../../../hooks/useEmployeeByDepartment";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}





const AddNewReturn = ({ handlecallback, editPurchaseOrderNumber, editPurchaseReceiveNumber, editReturnIndentID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  const callMessage = (serverityval, msg, title) => {
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };

  // List of Parameter


  const [customerNotes, setCustomerNotes] = useState('');
  const [orderFromDate, setOrderFromDate] = useState(dayjs());
  const [requestID, setRequestID] = useState('');
  const [isLoadEditPO, setLoadEditPO] = useState(false);


  const [tableRows, setTableRows] = useState([{ id_issue_det: 1, material_code: '', material_description: '', quantity_requested: 0, quantity_issued: 0, quantity_balance: 0, quantity_to_return: 0 }]);




  // get party list


  const [selectedButtonName, setSelectedButtonName] = useState('');

  const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);
  const { requestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
  const { issueIndentDetail, loadIssueDetailByIssueID, } = useLoadReturnIssueDetailByRequestNumber();
  const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID } = useEmployeeByDepartmentID();
  const { issuedNumberList, selectedIssuedIndentNumberList, selectedIssuedIndentNumberListID, setSelectedIssuedIndentNumberList, setSelectedIssuedIndentNumberListID, loadIssuedIndentNumbersByID, } = UseIssuedIndentNumberListOnReturn();
  const { returnIndentNumber, setReturnIndentNumber, loadReturnIndentNumberByID, } = useReturnIndentNumber(editReturnIndentID);
  const { processIndent } = useReturnIndentCRUD(callMessage);

  const callback = () => {
    handlecallback();
  }

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });





  useEffect(() => {
    if (Array.isArray(issueIndentDetail) && issueIndentDetail.length > 0) {
      setTableRows(issueIndentDetail);
      setRequestID(issueIndentDetail[0].request_number);
    }
  }, [issueIndentDetail]);


  useEffect(() => {
    const fetchEmployees = async () => {
      if (editReturnIndentID === 0) {
        if (selectedDepartmentID && selectedDepartmentID !== 0) {
          await loadEmployeeByID(selectedEmployeeID, selectedDepartmentID);
        }
      }
    };

    fetchEmployees();
  }, [selectedDepartmentID, selectedEmployeeID]); // Added selectedEmployeeID to the dependency array


  useEffect(() => {

    if (!isLoadEditPO && editReturnIndentID !== 0) {
      // setEditMode(true);
      try {
        const fetchData = async () => {

          const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_return: editReturnIndentID,
          };

          const purchaseOrderResponse = await callApi(API_ENDPOINTS.RETURN_INDENT_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
          const purchaseOrder = purchaseOrderResponse[0];

          if (purchaseOrder) {
            setReturnIndentNumber(purchaseOrder.return_issue_indent_number);
            setOrderFromDate(purchaseOrder.return_date);
            // setSelectedIssuedIndentNumberListID(purchaseOrder.id_issue);
            setCustomerNotes(purchaseOrder.notes);
            setRequestID(purchaseOrder.request_number);

            await loadIssuedIndentNumbersByID(purchaseOrder.id_issue);
            await loadDepartmentByID(purchaseOrder.id_department);
            await loadEmployeeByID(purchaseOrder.return_requested_by, purchaseOrder.id_department);
            await loadIssueDetailByIssueID(purchaseOrder.id_issue, purchaseOrder.return_issue_indent_number);
            // await loadIndentNumbersByDepartmentID(purchaseOrder.id_department, 'issue indent', purchaseOrder.id_request)

          }
        };

        fetchData();
      } catch (error) {
        callMessage('error', error.message, 'Error');
      }
    }

  }, [isLoadEditPO, editReturnIndentID]);


  const handleQuantityChange = (index, quantity) => {
    setTableRows((prevRows) => {
      return prevRows.map((row, i) => {
        if (i === index) {
          return row.quantity_balance < quantity
            ? row  // Return unchanged row if condition is not met
            : { ...row, quantity_to_return: quantity }; // Create a new object for state change detection
        }
        return row;
      });
    });
  };


  const handleSaveAndDraft = () => {

    const modifiedRows = tableRows.map(({ material_code, material_description, ...rest }) => rest);

    let mode_id = 0;
    if (editReturnIndentID != 0) {
      mode_id = 1;
    }
    let id_request = editReturnIndentID !== 0 ? editReturnIndentID : 0;

    const requestBody = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_mode: mode_id,
      p_id_return: id_request,
      p_id_issue: selectedIssuedIndentNumberListID,
      p_issue_indent_number: returnIndentNumber,
      // p_id_issuer: selectedEmployeeID,
      p_return_issue_indent_number: returnIndentNumber,
      p_id_department: selectedDepartmentID,
      p_return_requested_by: selectedEmployeeID,
      p_return_date: dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss'),
      p_status: 'Returned',
      p_returnitem_list: modifiedRows,
      p_notes: customerNotes,

    }
    processIndent(0, editReturnIndentID, requestBody);

  };



  useEffect(() => {
    if (editReturnIndentID === 0) {
      if (selectedIssuedIndentNumberListID > 0) {
        loadIssueDetailByIssueID(selectedIssuedIndentNumberListID, "");
      }

    }
  }, [selectedIssuedIndentNumberListID]);


  return (<>


    <Box padding={0}>

      <Header title={editReturnIndentID == 0 ? 'New Return Issue' : 'Edit Return Issue'} subtitle="" callback={callback} />
      <Divider />
      {editReturnIndentID > 0 && (
        <>
          <PurchaseReceiveActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} />
          <Divider />
        </>
      )}

      <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

      <Box
        sx={{
          padding: "5px",
          borderRadius: "10px",
          maxHeight: {
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          },
          overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.primary[400],
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.blueAccent[600],
            borderRadius: '10px',
            '&:hover': {
              background: colors.blueAccent[800],
            },
          },
          '&::-webkit-scrollbar-corner': {
            background: colors.primary[700],
          }
        }}>

        <Grid container  >
          {editReturnIndentID > 0 && (
            <>
              <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >

                <Grid container padding="10px 0px 15px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                  <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                      Return Indent #
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                    <TextField value={returnIndentNumber} fullWidth size="small" label="" required variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <CustomTooltip
                              title={
                                <span>
                                  <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                                </span>}
                            >
                              <SettingsIcon style={{ fontSize: "20px" }} />
                            </CustomTooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </>)}

          <Grid item xs={12} xl={12} >

            <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
              <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Return Indent No#
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                <TextField value={returnIndentNumber} fullWidth size="small" label="" required variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <CustomTooltip
                          title={
                            <span>
                              <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                            </span>}
                        >
                          <SettingsIcon style={{ fontSize: "20px" }} />
                        </CustomTooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Return Date
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={2}>
                    <DatePicker
                      size="small"
                      id="Orderdate"
                      value={dayjs(orderFromDate)}
                      onChange={(date) => setOrderFromDate(date)}
                      slotProps={{ textField: { size: 'small' } }}
                      fullWidth
                     format="DD-MMM-YYYY"

                      className="customDatePicker"
                      renderInput={(props) => (
                        <TextField required {...props} />
                      )}
                    />
                  </Stack>
                </LocalizationProvider>
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Issue Indent#
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={issuedNumberList}
                  value={selectedIssuedIndentNumberList}
                  onChange={(event, newValue) => {
                    setSelectedIssuedIndentNumberList(newValue);
                    setSelectedIssuedIndentNumberListID(newValue.id);
                    loadDepartmentByID(newValue.id_department);
                  }}
                  getOptionLabel={(option) => option.code || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Request Indent#
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                <TextField type="text" size="small" value={requestID}></TextField>
              </Grid>

            </Grid>
          </Grid>
          <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
              <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                Department
              </Typography>
            </Grid>

            <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
              <Autocomplete
                size="small"
                fullWidth
                options={department}
                value={selectedDepartment}
                disabled
                onChange={(event, newValue) => {
                  setSelectedDepartment(newValue);
                  setSelectedDepartmentID(newValue.id);
                }}
                getOptionLabel={(option) => option.description || ''}
                renderInput={(params) => (
                  <TextField {...params} label="" required variant="outlined" />
                )}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Return Requested By
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={employee}
                  value={selectedEmployee}
                  disabled={editReturnIndentID !== 0}
                  onChange={(event, newValue) => {
                    setSelectedEmployee(newValue);
                    setSelectedEmployeeID(newValue.id_employee);

                  }}
                  getOptionLabel={(option) => option.employee_name || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" />
                  )}
                />
              </Grid>

            </Grid>

          </Grid>
          {/* <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Approved By
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={employee}
                  value={selectedEmployee}
                  disabled={editRequestIndentID !== 0}
                  onChange={(event, newValue) => {
                    setSelectedEmployee(newValue);
                    setSelectedEmployeeID(newValue.id_employee);

                  }}
                  getOptionLabel={(option) => option.employee_name || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" />
                  )}
                />
              </Grid>

            </Grid>
          </Grid> */}

          <Grid item xs={12} lg={9.8} xl={6.5} mt={5} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
              <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                <CustomTableContainer colors={colors}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Matrial Code</TableCell>
                          <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Description</TableCell>
                          <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Issued</TableCell>
                           <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>UOM</TableCell>
                          <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Returned</TableCell>
                          {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>In Trasit</TableCell> */}
                          <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Quantity to Return</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableRows.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                              <TextField
                                fullWidth
                                disabled
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'center',
                                  },
                                }}
                                variant="outlined"
                                type="text"
                                value={`${row.material_code} `}
                              />
                            </TableCell>
                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                              <TextField
                                fullWidth
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'center',
                                  },
                                }}
                                value={row.material_description}
                                variant="outlined"
                                disabled
                              />
                            </TableCell>

                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                              <TextField
                                fullWidth
                                disabled
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'right',
                                  },
                                }}
                                variant="outlined"
                                type="number"
                                value={row.quantity_issued}

                              />
                            </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                              <TextField
                                fullWidth
                                disabled
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                   '& .MuiInputBase-root': {
        width: 'auto',        // 🔴 grow based on value
      },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'center',
                                  },
                                }}
                                variant="outlined"
                                type="text"
                                value={`${row.material_uom} `}
                              />
                            </TableCell>
                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                              <TextField
                                fullWidth
                                disabled
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'right',
                                  },
                                }}
                                variant="outlined"
                                type="number"
                                value={row.quantity_returned}
                              />
                            </TableCell>

                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                              <TextField
                                fullWidth
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'right',
                                  },
                                }}
                                variant="outlined"
                                type="number"
                                value={row.quantity_to_return}
                                onChange={(e) => handleQuantityChange(index, e.target.value)}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CustomTableContainer>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
            <Box padding={1} sx={{
              display: 'flex',
              alignItems: 'center',
              borderColor: 'divider',
              borderRadius: 2,
              color: 'text.secondary', '& svg': { m: 1, },
            }} >
              <Grid container spacing={0}>
                <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                  <Typography variant="h5" fontWeight="bold">Return Notes </Typography>
                  <Grid item xs={12} lg={12} xl={10}>
                    <TextField
                      id="outlined-multiline-static"
                      value={customerNotes}
                      onChange={(e) => setCustomerNotes(e.target.value)}
                      placeholder="Enter the issuer notes , will appear the issue indent."
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Grid container>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
          <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
            <Toolbar>
              <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Return</Button>
              <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
            </Toolbar>
          </Box>
        </Grid>
      </Grid>

    </Box>

  </>)
}
export default AddNewReturn;